// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1NneU","location":"Header_location__2RksP"};